/* eslint-disable max-lines */
import { animateScrollTop } from '@cian/ui/app/services/dom-utils.jsm';
import { plural } from '@cian/utils';
import { findIndex, get, isObject, pick } from 'lodash';
import { equals } from 'ramda';
import { SAVE_DRAFT_FAIL, SAVE_DRAFT_START, SAVE_DRAFT_SUCCESS } from '../../../../shared/actions/draft';
import { resetRosreestrData } from '../../../../shared/actions/rosreestrData';
import { getError } from '../../../../shared/components/CadastralNumbers/utils/getError';
import { KRASNOYARSK_REGION, NN_REGION, TATARSTAN_REGION, VORONEZH_REGION } from '../../../../shared/constants';
import {
  offerValidationFail,
  offerValidationSuccess,
  PUBLISH_OFFER_FAIL,
  PUBLISH_OFFER_START,
  PUBLISH_OFFER_SUCCESS,
  resetVisibleViolations,
  setCalltrackingEnabled,
  setVisibleViolations,
} from '../../../../shared/redux/reducers';
import { selectIsDealSaleOfferLabelEnabled } from '../../../../shared/selectors/abExperiments/selectIsDealSaleOfferLabelEnabled';
import {
  selectAnalyticsDealObjectString,
  selectAnalyticsFormType,
  selectAnalyticsOfferStatus,
} from '../../../../shared/selectors/analytics';
import { selectCurrency, selectIsNewOffer, selectOfferId, selectOfferStatus } from '../../../../shared/selectors/offer';
import { selectCadastralNumbers } from '../../../../shared/selectors/offer/selectCadastralNumbers';
import { selectPublishTermsDataForTracking } from '../../../../shared/selectors/publishTerms';
import {
  selectAutofields,
  selectCadastralFieldsMeta,
  selectRosreestrData,
  selectShowOverlay,
} from '../../../../shared/selectors/rosreestrData';
import { createMessageForAddForm } from '../../../../shared/services/createMessageForAddForm';
import {
  getAnalyticsProduct,
  getAnalyticsSiteType,
  getFirstOrSecondPhone,
  getUserTariff,
  listenEvent,
} from '../../../../shared/utils';
import { trackUtilitiesTermsActions } from '../../scripts/segment-inputs-config/price-and-deal-terms/utilities-terms/utilities-terms-input/tracking';
import { trackAuctionAddModalClose } from '../modals/modal-auction-add/modal-auction-add.tracking';
import { trackAuctionIncreaseModalClose } from '../modals/modal-auction-increase/modal-auction-increase.tracking';
import { setBSCenterAddress } from '../segments/address/address.events';
import { trackPubAvailPopupAction } from '../segments/pub-avail/PubAvail.tracking';
import {
  trackAuctionSendBid,
  trackClickOnDemandTrapBanner,
  trackFieldsAutofilled,
  trackOfferDraftSave,
  trackOfferDraftSaveFailByNoRedirect,
  trackPremoderationCheck,
  trackPublishByMisfilledFailed,
  trackPublishByMoneyFailed,
  trackPublishByUnfilledFailed,
  trackSelfEmployedEnabled,
  trackSendRosreestrRequest,
  trackSuccessfulMessage,
} from './AddForm.tracking';
import { RETRY_PUBLISH_TIMEOUT } from './constants';
import { formatRetryPublishCountdown, getModalDisplayedTimes, premoderationClean } from './utils';

export function AddFormCtrl(
  $scope,
  $rootScope,
  $sce,
  $log,
  $timeout,
  $interval,
  $window,
  adSegmentsService,
  categoryService,
  userIdentificationService,
  remoteValidationService,
  userService,
  adAssessmentService,
  adStateService,
  regions,
  countryCodes,
  popupService,
  analyticsService,
  adListenerService,
  pubAvailService,
  activeDraftService,
  placingTermsApi,
  bsCenterService,
  addFormLayoutService,
  addFormService,
  addressService,
  btiService,
  jkService,
  hiddenBaseService,
  authService,
  apiService,
  advertiseObjectService,
  expiredCookieService,
  subdomainDraftService,
  auctionApi,
  ivrService,
  headerPromoService,
  config,
  rentHelperService,
  publishErrorTelemetryService,
  deviceService,
  homeownerService,
  store,
  logger,
  httpApi,
  planService,
  coworkingService,
  publishTermsService,
  publishOfferService,
  commercialOwnerService,
  businessService,
  multiPostingService,
  formIdService,
) {
  'ngInject';

  Array.prototype.push.apply(regions, this.regions);
  Array.prototype.push.apply(countryCodes, this.countryCodes);

  if (this.savedAd !== null && typeof this.savedAd === 'object') {
    $rootScope.savedOffer = { ...this.savedAd };
    this.ad = this.savedAd;
  }

  if (Array.isArray(this.ad)) {
    this.ad = this.ad[0];
  }

  if (typeof this.ad !== 'object' || this.ad === null) {
    this.ad = {};
  }

  const that = this;

  const state = store.getState();
  const isNewOffer = selectIsNewOffer(state);
  const analyticsOfferStatus = selectAnalyticsOfferStatus(state);

  this.showOverlay = selectShowOverlay(state);
  this.rosreestrData = selectRosreestrData(state);
  this.autofields = selectAutofields(state);
  this.isDealSaleOfferLabelEnabled = selectIsDealSaleOfferLabelEnabled(state);
  this.canHideRestForm = false;
  this.canShowNextButton = false;

  store.subscribe(() => {
    const state = store.getState();
    const showOverlay = selectShowOverlay(state);
    const rosreestrData = selectRosreestrData(state);
    const autofields = selectAutofields(state);
    const isDealSaleOfferLabelEnabled = selectIsDealSaleOfferLabelEnabled(state);

    const showOverlayIsChanged = this.showOverlay !== showOverlay;
    const rosreestrDataIsChanged = this.rosreestrData !== rosreestrData;
    const autofieldsAreChanged = this.autofields !== autofields;
    const isDealSaleOfferLabelEnabledChanged = this.isDealSaleOfferLabelEnabled !== isDealSaleOfferLabelEnabled;

    if (showOverlayIsChanged) {
      this.showOverlay = showOverlay;
    }

    if (rosreestrDataIsChanged) {
      this.rosreestrData = rosreestrData;
    }

    if (autofieldsAreChanged) {
      this.autofields = autofields;
    }

    if (isDealSaleOfferLabelEnabledChanged) {
      this.isDealSaleOfferLabelEnabled = isDealSaleOfferLabelEnabled;
    }

    if (showOverlayIsChanged || rosreestrDataIsChanged || autofieldsAreChanged || isDealSaleOfferLabelEnabledChanged) {
      $scope.$applyAsync();
    }
  });

  const autofillSuburbanForm = (autofields, key) => {
    const autofilled = [];

    Object.entries(autofields).forEach(([fieldName, value]) => {
      if (typeof value === 'object') {
        autofilled.push(...autofillSuburbanForm(value, fieldName));

        return;
      }

      const fieldPath = [key, fieldName].filter(Boolean).join('.');
      const fieldValue = get(this.ad, fieldPath);
      const isAutofilled = typeof fieldValue === 'undefined' || fieldValue === null;

      if (isAutofilled) {
        addFormService.setValueByPath(fieldPath, value);
      }

      autofilled.push({ name: fieldName, isAutofilled });
    });

    return autofilled;
  };

  $scope.$watch(
    () => this.autofields,
    autofields => {
      const filledFields = autofillSuburbanForm(autofields);

      if (filledFields.some(({ isAutofilled }) => isAutofilled)) {
        trackFieldsAutofilled(filledFields);
      }
    },
  );

  const { deviceType } = config.get('adaptiveSettings') || {};

  let retryPublishCountdown = null;

  this.isMobile = deviceService.isMobile;

  $scope.analyticsOfferStatus = analyticsOfferStatus;

  addFormService.form = this.form;

  /**
   * Следим за перезаписью всего объекта this.ad
   * это происходит при инициализации формы и после логина на самой форме
   */
  $scope.$watch(
    () => this.ad,
    (ad, oldAd) => {
      this.categoryInfo = categoryService.getInfoByCategory(ad.category);
      addFormService.ad = ad; // храним ссылку на модель формы в сервисе
      if (ad === oldAd) {
        addFormService.setupDependentFields();
      }

      // нужно для определения лэйаута при открытии на редактирование до того, как отработает геокодер
      addressService.locationId = getLocationId();
    },
  );

  const setDefaultObjectGuid = () => {
    // TODO поменять на аналог подстановки черновика при билде
    if (!this.ad.objectGuid) {
      this.ad.objectGuid = window.addFormState.objectGuid;
    }
  };

  // получить последний сохраненный черновик пользователя, вызывается после авторизации
  const getActiveDraft = () => {
    activeDraftService.isActiveDraftEnabled().then(enabled => {
      if (enabled) {
        activeDraftService.getActiveDraft().then(draft => {
          this.ad = draft.data || {};
          if (this.ad.geo && this.ad.geo.address) {
            addressService.setAddressInfo(this.ad.geo.address);
          }
          if (this.ad.geo && this.ad.geo.jk && this.ad.geo.jk.name) {
            const { geoId, geoType } = this.ad.geo;

            const params = {
              geoId,
              geoType,
            };

            return apiService.jks({ params }).then(result => {
              const jkId = get(this.ad, 'geo.jk.id');
              const jkHouseId = get(this.ad, 'geo.jk.house.id');
              const jks = get(result, 'data.data.jks') || [];
              const jkData = jks.find(jk => jk.id === jkId);
              const jkDataHouses = get(jkData, 'houses') || [];
              const houseData = jkDataHouses.find(house => house.id === jkHouseId);
              if (jkData) {
                this.ad.geo.jk = {
                  ...this.ad.geo.jk,
                  ...jkData,
                };

                if (houseData) {
                  this.ad.geo.jk.house = {
                    ...this.ad.geo.jk.house,
                    ...houseData,
                  };
                }
              }
            });
          }
          setDefaultObjectGuid();
        });
      }
    });
  };

  adListenerService.provideAd(() => this.ad);

  setDefaultObjectGuid();
  formIdService.setId(this.ad.objectGuid);

  // событие должно уходить после получения objectGuid
  analyticsService.start();

  this.isAddressValid = false;
  this.previewCianLoading = false;
  this.debug = config.get('addformConfig.debug');
  this.draftAdProcess = false;
  this.publishAdProcess = false;
  this.isShowPublishSuccess = false;
  this.isShowPublishError = false;
  this.isShowIvrCheck = false;
  this.cianPreviewUrl = null;
  this.userService = userService;
  this.adAssessmentService = adAssessmentService;
  this.isFinallyPublished = null;
  this.demandMessageCreated = false;
  this.isRealtorHelpNeeded = placingTermsApi.isRealtorHelpNeeded;

  this.demandTrapBannerLink = require('../../resources/assets/images/realtor.png');
  this.userIdentificationService = userIdentificationService;
  this.headerPromoService = headerPromoService;

  //TODO переместить туда, где мы следим за таймером
  $scope.callButtonTimerText = '';
  this.callButtonTimerValue = 0;

  userService.setUser(this.user);

  const validationErrors = [
    'need_edit_announcement',
    'access_denied_for_premium_announcements',
    'access_denied_for_top3_announcements_by_rules',
    'service_used_max_time_in_period',
    'access_denied_for_publishing_new_announcements',
    'incorrect_status_announcement',
    'published_incorrect_status_announcement',
    'repeat_published_for_sold_announcement_possibly_month',
    'announcement_multy_disabled',
  ];

  const getLocationId = () => {
    let result;
    if (Array.isArray(get(this.ad.geo, 'address'))) {
      // Юматов: "нужно брать самый последний id с type=location"
      const locations = this.ad.geo.address.filter(address => address.type === 'location');
      if (locations.length > 0) {
        result = locations.pop().id;
      }
    }

    return result;
    // Если ничего не найдено, вернёт undefined
  };

  window.checkMessage = event => {
    const message = event.data || null;
    let preview;
    let previewPreloader;
    if (typeof message === 'string') {
      const params = message.split('|');
      if (params[0] === 'changeCianPreviewSize') {
        preview = document.getElementById('add_preview_cian');
        previewPreloader = document.getElementById('preview-block-preloader');
        params[1] = params[1] - 1;
      } else if (params[0] === 'changeDmirPreviewSize') {
        preview = document.getElementById('add_preview_dmir');
        previewPreloader = document.getElementById('preview-block-dmir-preloader');
        preview.style.width = params[1] + 'px';
      }
      if (preview && params.length > 2) {
        preview.style.height = params[2] + 'px';
        if (previewPreloader) {
          previewPreloader.style.display = 'none';
        }
      }
    }
  };

  window.previewCianLoaded = el => {
    if (el.src && that.previewCianLoading) {
      that.previewCianLoading = false;
    }
  };

  if (window.addEventListener) {
    window.addEventListener('message', window.checkMessage, false);
  } else if (window.attachEvent) {
    window.attachEvent('onmessage', window.checkMessage);
  }

  $rootScope.$on('callShowPublishSuccess', () => {
    showPublishSuccess(userIdentificationService.getDraftId());
  });

  const showIvrCheckScreen = () => {
    this.isShowIvrCheck = true;

    const gettingInterval = setInterval(async () => {
      const canCloseIvrCheckScreen = await apiService.getIsIvrCheckPassed();

      if (canCloseIvrCheckScreen) {
        clearInterval(gettingInterval);
        this.isShowIvrCheck = false;
        try {
          showPublishSuccess(this.ad.id);
        } catch (e) {
          logger.error(e);
        }
      }
    }, 10000);

    $scope.$applyAsync();
  };

  const showPublishSuccess = async offerId => {
    expiredCookieService.destroy();

    this.isShowPublishSuccess = true;
    this.previewCianLoading = true;
    this.isNewPublishedAd = !this.ad || this.ad.status !== 'published' || !this.ad.id;

    this.showGtmBanner = this.categoryInfo.dealType === 'rent';

    // помощник собственника
    this.showDemandTrap = this.ad.isByHomeowner && this.categoryInfo.dealType === 'rent';
    this.isHomeownerNeedHelp = this.ad.isByHomeowner && this.categoryInfo.dealType === 'sale';

    let previewPreloader = document.getElementById('preview-block-preloader');
    let previewDmirPreloader = document.getElementById('preview-block-dmir-preloader');
    if (previewPreloader) {
      previewPreloader.style.display = 'block';
    }
    if (previewDmirPreloader) {
      previewDmirPreloader.style.display = 'block';
    }

    animateScrollTop({
      to: 0,
      duration: 300,
      done: () => {},
    });

    this.cianPreviewUrl = getPreviewUrl(offerId);
    this.cianEditId = offerId;
    this.cianEditPath = `/razmestit-obyavlenie/${offerId}/`;
    // Устанавливаем id в сервис рекламы, чтобы из модального окна можно было послать запрос
    advertiseObjectService.offerId = offerId;

    // Если у пользователя был включен чекбокс, то отправляем запрос на рекламу автоматически
    if (userService.enableAdvertiseMyObject === true) {
      // Отключаем баннер, потому что запрос автоматический
      this.isAdvertiseMyObjectBannerVisible = false;
      // Убеждаемся еще раз, что мы можем послать автозапрос на рекламу
      if (advertiseObjectService.isCanAdvertiseObject() && advertiseObjectService.isUserInABGroup()) {
        advertiseObjectService.sendAdvertiseRequest(offerId);
      }
      // Если у пользователя выключен чекбокс, то смотрим можно ли показать баннер
    } else {
      // Сначала нужно понять, отображаем ли мы вообще баннер (но пока не отдаем в this, чтобы не рендерить)
      const isAdvertiseMyObjectBannerVisible = advertiseObjectService.isBannerVisible();
      // Нужно понять в какую группу попал пользователь для формирования ссылки на баннер
      const isAVariantAdvertiseBanner = isAdvertiseMyObjectBannerVisible && advertiseObjectService.getABGroup() === 'A';

      // Ссылка на баннер в зависимости от AB группы
      this.advertiseBannerLink = isAVariantAdvertiseBanner
        ? 'https://cdn-p.cian.site/images/static/advertise-banner-a.png'
        : 'https://cdn-p.cian.site/images/static/advertise-banner-b.png';

      this.isAdvertiseMyObjectBannerVisible = isAdvertiseMyObjectBannerVisible;
    }

    const isOnboardingIvrEnabled = config.get('addForm.ModerationOnboardingIvr.Enabled');

    // Определим, показывать ли пользователю попап с информацие об IVR
    if (isOnboardingIvrEnabled) {
      ivrService.fetchNeedPopup(offerId).then(status => {
        if (status === 'available') {
          ivrService.showPopup();
        }
      });
    }

    $scope.$applyAsync();
  };

  // Получаем ссылку для отображения превью в iframe
  const getPreviewUrl = id => {
    if (window.addFormState.cianPreviewUrl) {
      let url = window.addFormState.cianPreviewUrl.replace('<offerId>', id);
      // Если превью после идентификации, передаем флаг в шаблон
      if (!this.isFinallyPublished) {
        url += window.addFormState.cianPreviewUrl.indexOf('?') >= 0 ? '&identification' : '?identification';
      }

      return $sce.trustAsResourceUrl(url);
    }

    return null;
  };

  this.checkUserIdentification = id => {
    this.publishAdProcess = true;
    userIdentificationService.setDraftId(id);

    userIdentificationService
      .checkAvailableTasks()
      .then(() => {
        this.isFinallyPublished = false;
      })
      .catch(() => {
        popupService.openPopup('identificationError', {
          onClick: () => this.checkUserIdentification(id),
        });
      })
      .finally(() => {
        this.publishAdProcess = false;
      });
  };

  this.redirectAfterDraftSave = (id, redirectUrl) => {
    // Если есть колбек на сохранение драфта - вызываем его
    if (userIdentificationService.getPostDraftSaveCallback() != null) {
      userIdentificationService.getPostDraftSaveCallback()();
      this.draftAdProcess = false;
    } else {
      // Черновик сохранился, пользователю требуется идентификация через gosuslugi/sumsub и пользователь запросил публикацию
      if (
        id &&
        userIdentificationService.getIsUserNeedIdentification() &&
        userIdentificationService.getIsSaveInProcess()
      ) {
        analyticsService.saveDraftIdentification(this.ad.category);

        const isAgent = !addFormService.ad.isByHomeowner;
        const isNewFlow = pubAvailService.pubAvailData.identificationInstruction.onlyDocumentsAllowed;

        if (isAgent && isNewFlow) {
          this.checkUserIdentification(id);
          this.draftAdProcess = false;
        } else {
          userIdentificationService
            .markDraftAsNeedIdentification(id)
            .then(() => {
              this.checkUserIdentification(id);
            })
            .catch(() =>
              popupService.openPopup('identificationError', {
                onClick: () => this.checkUserIdentification(id),
              }),
            )
            .finally(() => (this.draftAdProcess = false));
        }
      } else {
        $timeout(() => {
          $window.location = redirectUrl;
        });
      }
    }
  };

  // По клику с баннера рекламы объекта открываем модальное окно подтверждения, которое сделает запрос
  this.openAdvertiseModal = () => {
    analyticsService.trackAdvertiseBannerClick();
    popupService.openPopup('advertiseObject');
  };

  this.checkForReload = () => {
    $window.location.assign(this.cianEditPath);
  };

  this.showPublishError = () => {
    this.closePublishError();

    let retryCountdown = RETRY_PUBLISH_TIMEOUT;

    $scope.retryPublishCountdownText = formatRetryPublishCountdown(retryCountdown);

    retryPublishCountdown = $interval(() => {
      retryCountdown--;

      $scope.retryPublishCountdownText = formatRetryPublishCountdown(retryCountdown);

      if (retryCountdown < 1) {
        if (publishTermsService.isNewPublishTermsEnabled()) {
          store.dispatch(publishOffer({ isPremoderationSkip: false }));
        } else {
          this.submitForm();
        }
      }
    }, 1000);

    this.isShowPublishError = true;
  };

  this.closePublishError = () => {
    this.isShowPublishError = false;

    if (retryPublishCountdown) {
      $interval.cancel(retryPublishCountdown);
    }
  };

  // Проверка статуса объявления
  const runCheckStatus = (offer, needShowIvrCheckScreen) => {
    if (this.currentCheckStatusTimeout) {
      $timeout.cancel(this.currentCheckStatusTimeout);
    }

    apiService
      .offerStatus(offer.objectGuid)
      .then(response => {
        const offerId = get(response, 'data.data.id');
        const status = get(response, 'data.data.status');
        const publishingStage = get(response, 'data.data.publishingStage');

        // Записываем ID объявления для удобства трекинга событий
        offer.id = offerId;

        if (offerId && publishingStage === 'billed' && status === 'published') {
          this.publishAdProcess = false;
          this.isFinallyPublished = true;

          analyticsService.adPublished({
            offer,
            isRealtorHelpNeeded: placingTermsApi.isRealtorHelpNeeded,
            publishType: 'deffered',
            isShortForm: addFormLayoutService.isShortForm,
            offerStatus: analyticsOfferStatus,
            publishTerms: selectPublishTermsDataForTracking(store.getState()),
          });

          if (needShowIvrCheckScreen) {
            showIvrCheckScreen();
          } else {
            showPublishSuccess(offerId);
          }
        } else {
          this.currentCheckStatusTimeout = $timeout(() => {
            runCheckStatus(offer, needShowIvrCheckScreen);
          }, 2000);
        }
      })
      .catch(e => {
        this.publishAdProcess = false;
        this.showPublishError();

        try {
          throw new Error(JSON.stringify(pick(e, ['status', 'statusText', 'data']))); // send to sentry
        } catch (_) {
          // Ничего не делаем, так как поведение валидно неожиданное. Вот такой вот парадокс.
        }
      });
  };

  this.checkGeneralRemoteErrors = errors => {
    if (errors['']) {
      popupService.openPopup('validationError', {
        errorName: null,
        errorMessage: errors[''].message || errors[''][0].message || 'Ошибка. Попробуйте позже.',
      });

      delete errors[''];
    }

    if (errors.not_enough_money) {
      const codeToPopup = {
        7: 'refillBalance',
        11: 'refillAgencyBalance',
      };

      trackPublishByMoneyFailed({
        isShortForm: addFormLayoutService.isShortForm,
        offerId: this.ad.id,
        offerStatus: analyticsOfferStatus,
      });

      popupService.openPopup(codeToPopup[errors.not_enough_money[0].code]).result.then(action => {
        if (action === 'saveDraft') {
          this.ad.status = 'draft';
          this.submitForm();
        }
      });

      delete errors.not_enough_money;
    }

    validationErrors.forEach(val => {
      if (errors[val]) {
        popupService.openPopup('validationError', {
          errorName: val,
          errorMessage: errors[val].message || errors[val][0].message || 'Ошибка. Попробуйте позже.',
        });
        delete errors[val];
      }
    });

    /*
      Отображение ошибки номера телефона
    */
    const phoneErrorRegexp = /^(phones\.[0,1])\.(.*)$/;
    const capitalizeCode = code => {
      return code.charAt(0).toUpperCase() + code.slice(1);
    };
    for (const errorKey in errors) {
      if (Object.prototype.hasOwnProperty.call(errors, errorKey) && phoneErrorRegexp.test(errorKey)) {
        const [, phoneErrorKey, phoneErrorKeyCode] = phoneErrorRegexp.exec(errorKey);
        if (phoneErrorKey) {
          const phoneErrorSource = errors[errorKey];
          for (const phoneErrorElement of phoneErrorSource) {
            phoneErrorElement.code += capitalizeCode(phoneErrorKeyCode);
          }
          if (!Object.prototype.hasOwnProperty.call(errors, phoneErrorKey)) {
            errors[phoneErrorKey] = [];
          }
          errors[phoneErrorKey] = [].concat(errors[phoneErrorKey], phoneErrorSource);
          delete errors[errorKey];
        }
      }
    }
    if (this.segments.indexOf('phone-verify') > -1 && errors['phones.0'] && errors['phones.0'][0]) {
      $rootScope.$broadcast('publish.invalidNumber', errors['phones.0'][0]);
      delete errors['phones.0'];
    }
  };

  const prepublishReset = () => {
    this.closePublishError();

    if (this.currentCheckStatusTimeout) {
      $timeout.cancel(this.currentCheckStatusTimeout);
    }

    this.publishAdProcess = false;
    this.draftAdProcess = false;
    this.premoderationAdProcess = false;

    const state = store.getState();
    const offerStatus = selectOfferStatus(state);

    this.ad.status = offerStatus || 'published';

    this.form.remoteValidator.removeFieldErrors();

    store.dispatch(resetVisibleViolations());
  };

  const checkFormValidity = offerId => {
    addFormLayoutService.setLayout();

    const state = store.getState();

    const { cadastralNumber } = selectCadastralNumbers(state);

    const {
      cadastralNumber: { errors, isRequired },
    } = selectCadastralFieldsMeta(state);

    const isInvalidCadastralNumber = isRequired && !!getError(errors, cadastralNumber);

    const isInvalidForm = this.form.$invalid || isInvalidCadastralNumber;

    if (isInvalidForm) {
      const { isShortForm } = addFormLayoutService;

      publishErrorTelemetryService.sendTelemetryMessage();

      this.form.remoteValidator.scrollToFirstError(this.form);

      if (this.form.$error && this.form.$error.required && this.form.$error.required.length) {
        trackPublishByUnfilledFailed({
          isShortForm,
          offerId,
          offerStatus: analyticsOfferStatus,
        });
      } else {
        trackPublishByMisfilledFailed({
          isShortForm,
          offerId,
          offerStatus: analyticsOfferStatus,
        });
      }
    }

    return isInvalidForm;
  };

  const runPremoderationCheck = async ({ offer, isPremoderationSkip }) => {
    if (offer.status === 'draft') {
      return true;
    }

    const { isShortForm } = addFormLayoutService;

    this.premoderationAdProcess = true;

    const premoderationOffer = premoderationClean(offer);

    // Добавляем cianUserId для премодерации у объявлений с КП, если этого поля нет
    const premoderationModel = {
      cianUserId: premoderationOffer.kp ? userService.user.cianUserId : undefined,
      ...adStateService.cleanAdModel(premoderationOffer),
    };

    // Отправляем запрос на премодерацию
    const { isValid, payload } = await publishOfferService.checkVisibleViolations(
      premoderationModel,
      isPremoderationSkip,
    );

    trackPremoderationCheck({
      isValid,
      isShortForm,
      offerStatus: analyticsOfferStatus,
      formId: formIdService.getId(),
    });

    this.premoderationAdProcess = false;

    $scope.$apply();

    if (isValid) {
      store.dispatch(offerValidationSuccess());
    } else {
      store.dispatch(offerValidationFail());
      store.dispatch(setVisibleViolations(payload));

      premoderationErrorsProcess(payload);

      $rootScope.$broadcast('premoderationErrors');
    }

    return isValid;
  };

  this.submitForm = async (isPremoderationSkip = false) => {
    $rootScope.$broadcast('addform.submit');

    prepublishReset();

    const offer = angular.copy(this.ad);

    const isFormInvalid = checkFormValidity(offer.id);

    if (isFormInvalid) {
      return;
    }

    const isPremoderationCheckSuccess = await runPremoderationCheck({ offer, isPremoderationSkip });
    if (!isPremoderationCheckSuccess) {
      return;
    }

    if (multiPostingService.isShowPopup(offer)) {
      const popup = popupService.openPopup('multiPostingConfirm');
      popup.result
        .then(() => {
          offer.multiposting.enabled = true;
          publishOffer(offer);
        })
        .catch(() => {
          publishOffer(offer);
        });
    } else {
      auctionCheck(offer);
    }
  };

  // Аукцион ↓
  const auctionCheck = offer => {
    const {
      auctionOption,
      selected: { option },
      processPublishTerm,
      stepBet,
      isAdditionalCompatible,
      isAdditionalSelected,
    } = placingTermsApi;

    if (!auctionOption || offer.status === 'draft' || !offer.publishTerms) {
      publishOffer(offer);

      return;
    }

    const isAuctionCompatible = isAdditionalCompatible(auctionOption, option);
    const isAuctionSelected = isAdditionalSelected(auctionOption);
    const isAuctionPaid = auctionOption.selectedPeriod.isPaid;
    const currentAuctionBet = auctionOption.dynamicPrice;
    const previousAuctionBet = auctionOption.sourceBet;
    const isAuctionTriggerModalsEnabled =
      document.cookie.indexOf('isAuctionTriggerModalsDisabled') === -1 && !$rootScope.shouldSkipPublishModals;

    if (isAuctionTriggerModalsEnabled && isAuctionCompatible) {
      if (isAuctionSelected) {
        let popupSettings;

        if (!isNewOffer && !currentAuctionBet) {
          popupSettings = {
            title: 'Вы отменяете ставку',
            bet: currentAuctionBet,
            isDecreasingBet: false,
          };
          // Ставка была понижена пользователем при редактировании
        } else if (!isNewOffer && currentAuctionBet < previousAuctionBet) {
          popupSettings = {
            title: 'Вы понижаете ставку!',
            bet: currentAuctionBet,
            isDecreasingBet: true,
          };
        } else if (
          // Пользователь не менял ставку или оставил по умолчанию
          (currentAuctionBet === previousAuctionBet || currentAuctionBet === stepBet) &&
          // Нет удержания ставки на аккаунт
          !auctionOption.isAuctionBetHolded &&
          // У объявления ещё нет ID или модалка отображалась за последние сутки менее 2-х раз
          (!offer.id || getModalDisplayedTimes('auctionIncrease' + offer.id) < 2)
        ) {
          auctionApi
            .getRecommendedBet(currentAuctionBet)
            .then(({ data }) => {
              const {
                increaseRecommendedBetsPositionsCount,
                recommendedBet,
                /** Количество объявлений выше по всем VAS */
                betFullConcurrency,
                /** Количество объявлений выше в рамках текущего VAS */
                betServiceConcurrency,
              } = data;

              /** Флаг: включена ли сквозная конкуренция */
              const isPenetratingConcurrencyEnabled =
                Number.isFinite(betFullConcurrency) && Number.isFinite(betServiceConcurrency);

              /** Флаг: нужно ли показывать модальное окно, предупреждающее о низкой позиции в выдаче */
              const isIncreaseModalNotNeeded = isPenetratingConcurrencyEnabled
                ? betFullConcurrency < 3
                : increaseRecommendedBetsPositionsCount < 3;

              if (isIncreaseModalNotNeeded) {
                publishOffer(offer);

                return;
              }

              /** Текущая позиция: при включенной сквозной конкуренции берем позицию среди всех VAS */
              const currentPosition = isPenetratingConcurrencyEnabled
                ? betFullConcurrency
                : increaseRecommendedBetsPositionsCount;

              popupService
                .openPopup('auctionIncrease', {
                  // Настройки передаются в скоуп контроллера модального окна
                  settings: {
                    currentPosition,
                    // Выбранный VAS на форме выбора услуг
                    option,
                    currentBet: currentAuctionBet,
                    recommendedBet,
                    betStep: stepBet,
                    betServiceConcurrency,
                  },
                })
                .result.then(bet => {
                  const auctionTermIndex = findIndex(offer.publishTerms.terms, term => term.services[0] === 'auction');

                  offer.publishTerms.terms[auctionTermIndex].dynamicPrice = bet;
                  auctionOption.dynamicPrice = bet;

                  trackAuctionIncreaseModalClose('add_bid', bet);

                  publishOffer(offer);
                })
                .catch(() => {
                  trackAuctionIncreaseModalClose('continue', currentAuctionBet);

                  publishOffer(offer);
                });
            })
            .catch(() => {
              $scope.isFetching = false;
            });

          return;
        }

        if (popupSettings) {
          popupService
            .openPopup('auctionConfirm', {
              settings: popupSettings,
            })
            .result.then(() => {
              publishOffer(offer);
            });

          return;
        }

        publishOffer(offer);

        return;
      } else if (!auctionOption.isAuctionBetHolded) {
        if (isAuctionPaid) {
          popupService
            .openPopup('auctionConfirm', {
              settings: {
                title: 'Вы отменяете ставку',
                bet: currentAuctionBet,
                isDecreasingBet: false,
              },
            })
            .result.then(() => {
              publishOffer(offer);
            });

          return;
        }

        if (
          // У объявления ещё нет ID или модалка не отображалась за последние сутки и объявление не в сделке
          !offer.id ||
          getModalDisplayedTimes('auctionAdd' + offer.id) === 0
        ) {
          popupService
            .openPopup('auctionAdd')
            .result.then(() => {
              const auctionTerm = processPublishTerm(auctionOption);

              auctionTerm.dynamicPrice = stepBet;
              auctionOption.dynamicPrice = stepBet;

              offer.publishTerms.terms.push(auctionTerm);

              trackAuctionAddModalClose('add_bid', stepBet);

              publishOffer(offer);
            })
            .catch(() => {
              trackAuctionAddModalClose('continue', 'free');

              publishOffer(offer);
            });

          return;
        }
      }
    }

    publishOffer(offer);
  };
  // Аукцион ↑

  const premoderationErrorsProcess = data => {
    const _errors = {};

    data.errors.forEach(error => {
      if (!_errors[error.key]) {
        _errors[error.key] = [];
      }

      _errors[error.key].push(error);
    });

    data.errors = _errors;

    this.form.remoteValidator.setValidators(data);

    publishErrorTelemetryService.sendTelemetryMessage();
  };

  this.sendMessageFromAddform = () => {
    if (!placingTermsApi.isRealtorHelpNeeded) {
      trackClickOnDemandTrapBanner(analyticsOfferStatus);
    }

    const { dealType } = this.categoryInfo;
    const state = store.getState();
    const currency = selectCurrency(state);

    const messageData = {
      address: this.ad.geo.userInput,
      category: this.ad.category,
      dealType,
      email: this.user.email,
      phone: getFirstOrSecondPhone(this.ad.phones),
      price: this.ad.bargainTerms.price,
      currency,
      source: placingTermsApi.isRealtorHelpNeeded ? 'AddNewOffer_checkbox' : 'AddNewOffer_successPage',
    };

    createMessageForAddForm({ context: { logger, httpApi }, parameters: messageData }).then(() => {
      this.demandMessageCreated = true;

      trackSuccessfulMessage(analyticsOfferStatus);
    });
  };

  const setupRemoteErrors = data => {
    if (data.errors) {
      this.checkGeneralRemoteErrors(data.errors);
    }

    this.form.remoteValidator.setValidators(data);

    publishErrorTelemetryService.sendTelemetryMessage();
  };

  const processRemoteErrors = data => {
    /**
     * Переключаем на полную форму чтобы показать ошибки.
     * Ошибки могут относиться к полям которые скрыты.
     */
    if (addFormLayoutService.isShortLayout) {
      addFormLayoutService.setShortForm(false, true);

      // Помечаем форму как нетронутая, чтобы попап ошибки пока не показывался
      this.form.$setPristine();

      // Таймаут, чтобы дождаться когда поля смонтируются в дом, иначе будет попап о том, что поля не найдены
      $timeout(() => {
        setupRemoteErrors(data);

        // На этом моменте считаем что открыта полная форма
        // Поля смонтированы
        // Ставим форме отправленное состояние - этим добьемся правильного положения для тултипа
        this.form.$setSubmitted();
      }, 0);
    } else {
      setupRemoteErrors(data);
    }
  };

  const publishOffer = offer => {
    this.closePublishError();

    if (!placingTermsApi.isMultiPostingAvailable) {
      offer.multiposting = {
        enabled: false,
      };
    }

    // Удаляем элементы массива где кол-во null
    const cranageTypes = (offer && offer.building && offer.building.cranageTypes) || [];
    if (cranageTypes.length > 0) {
      offer.building.cranageTypes = cranageTypes.filter(item => item.count);
    }

    const liftTypes = (offer && offer.building && offer.building.liftTypes) || [];
    if (liftTypes.length > 0) {
      offer.building.liftTypes = liftTypes.filter(item => item.count);
    }

    if (offer.status === 'published') {
      const doPublish = () => {
        this.publishAdProcess = true;

        adStateService.publish(offer, true).then(publishOfferSuccess, publishOfferFail);
      };

      this.publishAdProcess = true;

      /**
       * Если включено размещение в Закрытую базу, не нужно дергать условия размещения и биллинг
       */
      if (hiddenBaseService.isEnabled()) {
        doPublish();
      } else {
        placingTermsApi
          .checkPublish(() => doPublish(), undefined, { allowServerErrors: true })
          .then(modalShown => {
            if (modalShown) {
              this.publishAdProcess = false;
            }
          })
          .catch(response => {
            if (response && response.rejectedFromRetry) {
              analyticsService.publishByPrepublishFailed({
                isShortForm: addFormLayoutService.isShortForm,
                offerId: offer.id,
              });

              this.publishAdProcess = false;
              popupService.openPopup('checkPublishError');
            } else {
              doPublish();
            }
          });
      }

      if (placingTermsApi.isRealtorHelpNeeded) {
        this.sendMessageFromAddform();
      }
    } else {
      this.draftAdProcess = true;

      if (offer.publishTerms) {
        delete offer.publishTerms;
      }

      adStateService.publish(offer).then(saveDraftSuccess, saveDraftFail);
    }
  };

  const publishOfferSuccess = ({ response }) => {
    const offerId = get(response, 'data.id');
    const status = get(response, 'data.status');
    const needShowIvrCheckScreen = get(response, 'data.showIvrCheckScreen');

    // При публикации удаляем сохраненный активный черновик
    activeDraftService.deleteDraft(this.ad.objectGuid);
    activeDraftService.setLocalAutoSave(false);

    // Записываем ID объявления для удобства трекинга событий
    this.ad.id = offerId;

    if (
      offerId &&
      (status !== 'waitForPublish' ||
        (status === 'waitForPublish' &&
          ['premoderation', 'user', 'defferedPublication'].includes(response.data.draftReason)))
    ) {
      const amount = placingTermsApi.getTotalPriceAmount();
      const calltrackingState =
        placingTermsApi.isCalltrackingAvailable && placingTermsApi.isCalltrackingSelected() ? 'on' : 'off';
      const isAdvertiseEnabled = userService.enableAdvertiseMyObject;

      const isSelfEmployed = get(this.ad, 'selfEmployedData.inn', false);

      analyticsService.adPublished({
        offer: this.ad,
        isRealtorHelpNeeded: placingTermsApi.isRealtorHelpNeeded,
        publishType: 'instant',
        isShortForm: addFormLayoutService.isShortForm,
        offerStatus: analyticsOfferStatus,
        publishTerms: selectPublishTermsDataForTracking(store.getState()),
      });
      analyticsService.publishSuccess(addFormLayoutService.isShortForm, this.ad.category);
      analyticsService.sendPromoteAdComplete(
        this.ad.publishTerms,
        offerId,
        amount,
        calltrackingState,
        isAdvertiseEnabled,
      );

      if (this.isHomeownerConfirmationSent()) {
        trackSendRosreestrRequest(analyticsOfferStatus);
      }

      if (this.ad.bargainTerms?.utilitiesTerms) {
        trackUtilitiesTermsActions(this.ad.bargainTerms.utilitiesTerms, offerId);
      }

      if (isNewOffer && isSelfEmployed) {
        trackSelfEmployedEnabled();
      }

      // ↓ Аукцион
      const { auctionOption } = placingTermsApi;

      if (auctionOption && (!!auctionOption.dynamicPrice || !!auctionOption.sourceBet)) {
        const isAuctionSelected = placingTermsApi.isAdditionalSelected(auctionOption);
        const price = isAuctionSelected ? auctionOption.dynamicPrice : 0;

        const state = store.getState();

        const analyticsProduct = getAnalyticsProduct(state, placingTermsApi);

        trackAuctionSendBid(price, analyticsProduct);
      }
      // ↑ Аукцион

      this.isFinallyPublished = true;
      this.publishAdProcess = false;
      if (needShowIvrCheckScreen) {
        showIvrCheckScreen();
      } else {
        showPublishSuccess(offerId);
      }

      $scope.$applyAsync();
    } else {
      runCheckStatus(this.ad, needShowIvrCheckScreen);

      analyticsService.publishFailedByResponse({
        responseData: response.data,
        isShortForm: addFormLayoutService.isShortForm,
        offerId,
      });
    }
  };

  const publishOfferFail = ({ statusCode, response }) => {
    const { id: offerId } = this.ad;

    if (statusCode === 400 && !!response.data) {
      processRemoteErrors(response.data);
    }

    if (statusCode === 403) {
      analyticsService.publishByUnauthorizedFailed({
        isShortForm: addFormLayoutService.isShortForm,
        offerId,
      });

      formIsBlocked = true;
    } else if (response?.data) {
      analyticsService.publishFailedByResponse({
        responseData: response.data,
        isShortForm: addFormLayoutService.isShortForm,
        offerId,
      });
    }

    this.publishAdProcess = false;

    $scope.$apply();
  };

  const saveDraftSuccess = ({ response }) => {
    const draftId = get(response, 'data.id');
    const redirectUrl = userIdentificationService.getIdentificationLink() || get(response, 'data.redirectUrl');

    const state = store.getState();

    if (response && response.data && redirectUrl) {
      const dealObject = selectAnalyticsDealObjectString(state);

      trackOfferDraftSave({ dealObject, offerStatus: analyticsOfferStatus });

      if (pubAvailService.showPopup) {
        trackPubAvailPopupAction(pubAvailService.pubAvailData.windowModeType, 'Save');
      }

      this.redirectAfterDraftSave(draftId, redirectUrl);
    } else {
      const offerId = selectOfferId(state);
      const formType = selectAnalyticsFormType(state);

      const siteType = getAnalyticsSiteType(deviceType);

      trackOfferDraftSaveFailByNoRedirect({ formType, siteType, offerId, offerStatus: analyticsOfferStatus });

      $rootScope.$broadcast('http.serverError', response);

      this.draftAdProcess = false;
    }

    $scope.$apply();
  };

  const saveDraftFail = ({ response, statusCode }) => {
    if (statusCode === 400) {
      if (response && response.data) {
        const data = response.data;

        if (data.errors) {
          this.checkGeneralRemoteErrors(data.errors);
        }

        this.form.remoteValidator.setValidators(data);

        publishErrorTelemetryService.sendTelemetryMessage();
      }
    }

    this.draftAdProcess = false;
  };

  this.clear = () => {
    this.form.$setPristine();
    this.ad = {
      objectGuid: this.ad.objectGuid,
      category: null,
      // Если оставить geo, то не будет инициализации при повторном открытии карты, после клика по Очистка формы
      // Когда мы убираем объект geo, при инициализации yandex карты, будут установлены дефолтные значения,
      // что и нужно после очистки формы
      photos: [],
      cadastralNumber: undefined,
      buildingCadastralNumber: undefined,
    };
    store.dispatch(resetRosreestrData());
    activeDraftService.deleteDraft(this.ad.objectGuid);
    this.categoryInfo = {};
    addFormLayoutService.init();
    $rootScope.$broadcast('addform.clear', this.ad);
  };

  function createNew() {
    $window.location.assign('/razmestit-obyavlenie/');
  }

  this.createNewInProgress = false;
  this.createNew = () => {
    this.createNewInProgress = true;
    activeDraftService
      .isActiveDraftEnabled()
      .then(isEnabled => {
        if (isEnabled) {
          return activeDraftService.deleteDraft();
        }
      })
      .then(() => {
        createNew();
      })
      .catch(() => {
        createNew();
      });
  };

  const handleServerError = data => {
    // Запрет на открытие попапа с ошибкой, если предыдущий ещё активен
    if (!this.errorPopupInstance) {
      this.errorPopupInstance = popupService.openPopup('serverError');

      this.errorPopupInstance.closed.then(() => {
        this.errorPopupInstance = null;
      });
    }

    $log.error('Ошибка сервера: ', data);

    try {
      logger.error(JSON.stringify(data));
    } catch (e) {
      logger.error('Addform server error. Cannot parse error data, check logged server errors.');
    }
  };

  $scope.$watch(
    () => placingTermsApi.isRealtorHelpNeeded,
    newValue => {
      this.isRealtorHelpNeeded = newValue;
    },
  );

  this.onCallAgainClick = () => {
    const startMoment = new Date().valueOf();
    const interval = setInterval(() => {
      const currentMoment = new Date().valueOf();
      const passedSeconds = Math.ceil((currentMoment - startMoment) / 1000);
      const waitingTimeInSeconds = 60;
      this.callButtonTimerValue = Math.max(waitingTimeInSeconds - passedSeconds, 0);

      $scope.callButtonTimerText = `Сможем перезвонить ещё раз через ${this.callButtonTimerValue} ${plural(
        this.callButtonTimerValue,
        ['секунду', 'секунды', 'секунд'],
      )}`;

      if (this.callButtonTimerValue === 0) {
        $scope.callButtonTimerText = '';
        clearInterval(interval);
      }

      $scope.$applyAsync();
    }, 950);
  };

  $scope.$watchGroup(
    [() => this.ad.category, () => this.ad.coworkingOfferType, () => this.ad.readyBusinessType],
    (newValues, oldValues) => {
      const [category, coworkingOfferType, readyBusinessType] = newValues;
      const [oldCategory, oldCoworkingOfferType, oldReadyBusinessType] = oldValues;

      if (this.form.$submitted) {
        this.form.$setPristine();
        this.form.$setUntouched();
      }

      // Если старая категория была БЦ, а новая не БЦ, надо отвязать БЦ, если он привязан
      if (
        bsCenterService.isBSCategory(oldCategory) &&
        !bsCenterService.isBSCategory(category) &&
        bsCenterService.isBSCenterAttached()
      ) {
        // addFormLayoutService.setShortForm(false, true);
        bsCenterService.detachBSCenter();
      }

      // Это условие может не срабатывать, так как при смене Типа сделки или Типа недвижимости новая категория null, пока не будет выбран Объект
      // Это условие сработает при смене Объекта, если не менять Тип сделки и Тип недвижимости
      const categoryChanged =
        (category && oldCategory && category !== oldCategory) || (oldCategory && category === null);

      // офис и коворкинг одной категории - officeRent
      // поэтому дополнительно проверяем изменилось ли поле coworkingOfferType
      const coworkingOfferTypeChanged = coworkingOfferType !== oldCoworkingOfferType;

      const changedCategoryFromOfficeToCoworking = !categoryChanged && !oldCoworkingOfferType && coworkingOfferType;

      const readyBusinessTypeChanged = readyBusinessType !== oldReadyBusinessType;

      if (categoryChanged || coworkingOfferTypeChanged || readyBusinessTypeChanged) {
        addFormLayoutService.setLayout(); // Перевычисляем вариант отображения превью адреса
        // Если короткая форма доступна, включаем полную форму
        // Далее по коду будет запущено получение данных от АПИ и на основе этих данных форма будет повторно схлопнута в короткую
        if (addFormLayoutService.isShortLayout) {
          addFormLayoutService.setShortForm(false, true);
        }

        // если перешли из офиса в коворкинг, то дополнительно проверяем coworkingOfferType
        // потому что пока для коворкингов должна быть выключена привязка к БЦ
        if (bsCenterService.isBSCategory(category) && changedCategoryFromOfficeToCoworking) {
          // при смене категории ищем БЦ/ТЦ по адресу
          if (addressService.isHouse() && !bsCenterService.isBSCenterAttached()) {
            // addFormLayoutService.setShortForm(false, true);
            bsCenterService.fillBSCenterDataByAddress().then(bsCenter => {
              if (bsCenter) {
                $rootScope.$emit(setBSCenterAddress, bsCenter.geo); // берем гео из БЦ
                addFormLayoutService.setRevertValues();
              }
              addFormLayoutService.setShortForm(!!bsCenter);
            });
          } else if (bsCenterService.isBSCenterAttached()) {
            // Если переключаемся с БЦ на БЦ и есть привязанный БЦ сворачиваем в короткую форму
            addFormLayoutService.setShortForm(true);
          }
        }

        if (!bsCenterService.isBSCategory(category) && bsCenterService.isBSCenterAttached()) {
          bsCenterService.detachBSCenter();
        }

        if (
          !bsCenterService.isBSCategory(category) &&
          btiService.isBtiCategory() &&
          addressService.isHouse() &&
          !coworkingService.isCoworkingCategory()
        ) {
          btiService.processBti(this.ad);
        }

        // Если выбран нековоркинг, то удаляем поле за ненадобностью
        if (oldCoworkingOfferType && !coworkingOfferType) {
          delete this.ad.coworking;
          delete this.ad.bargainTerms.priceForWorkplace;
          delete this.ad.bargainTerms.price;
          delete this.ad.bargainTerms.minLeaseTerm;
          delete this.ad.bargainTerms.includedOptions;
          delete this.ad.workplaceCount;
          delete this.ad.totalArea;
          delete this.ad.floorNumber;
          delete this.ad.coworkingOfferType;
        }

        if (coworkingService.isCoworkingCategory()) {
          coworkingService.attachSingleCoworking();
        }

        if (readyBusinessTypeChanged) {
          businessService.onReadyBusinessTypeChange();
        }

        if (coworkingOfferType) {
          addFormService.setValueByPath('conditionType', undefined);
        }
      }
    },
  );

  /**
   * При явном переключении на короткую форму (по клику на таб), откатываем невалидные значения полей блока "О здании"
   * к значениям из каталога (при создании нового объявления) или начальным значениям из объявления (при редактировании)
   */
  addFormLayoutService.onIsShortFormChange(({ isShortForm, explicit }) => {
    if (isShortForm && explicit) {
      addFormLayoutService.revertInvalidFields(this.form);
    }
  });

  // после привязки БТИ сохраняем значения полей для восстановления при переключени на короткую форму
  btiService.onProcess(() => {
    addFormLayoutService.setLayout();
    if (addFormLayoutService.isShortLayout) {
      addFormLayoutService.setRevertValues();
    }
  });

  const updateSegments = () => {
    const objectType = this.categoryInfo && this.categoryInfo.objectType;
    const rentDuration = this.categoryInfo && this.categoryInfo.rentDuration;
    const showRentHelper = rentHelperService.showRentHelperTrap();
    let segments;

    segments = adSegmentsService.getSegments({
      objectType,
      rentDuration,
      ignoreShortForm: false,
      showIndexingDelayAlert: config.get('addForm.indexingDelayAlert.show'),
      showRentHelperTrap: showRentHelper,
      showHomeownerWarning: homeownerService.getHomeOwnerWarningVisibility(this.ad),
      isCommercialBusinessAvailable: businessService.getReadyBusinessTypeSelected(),
      rosreestrData: this.rosreestrData,
    });

    if (objectType === 'coworking') {
      segments = coworkingService.getCoworkingSegments(segments);
    }

    planService.onSegmentsChange();

    if (!equals(segments, this.segments)) {
      this.segments = segments;

      if (this.ad.category !== undefined) {
        analyticsService.addFormStep2(this.ad.category);
      }
    }
  };

  const isFlatSale = () => {
    const objectType = this.categoryInfo && this.categoryInfo.objectType;
    const dealType = this.categoryInfo && this.categoryInfo.dealType;

    return objectType === 'flat' && dealType === 'sale';
  };

  const isCountrySide = () => {
    const objectType = this.categoryInfo && this.categoryInfo.objectType;
    const dealType = this.categoryInfo && this.categoryInfo.dealType;
    const isDaily = this.categoryInfo && this.categoryInfo.rentDuration === 'short';

    const {
      sale: saleObjectTypes = ['house', 'houseShare', 'townhouse', 'land'],
      rent: rentObjectTypes = [],
      dailyRent: daylyRentObjectTypes = [],
    } = config.get('Countryside.newFPCategories') || {};

    return (
      (dealType === 'sale' && saleObjectTypes.includes(objectType)) ||
      (dealType === 'rent' && !isDaily && rentObjectTypes.includes(objectType)) ||
      (dealType === 'rent' && isDaily && daylyRentObjectTypes.includes(objectType))
    );
  };

  const isCommercialNewFpCategory = () => {
    const objectType = this.categoryInfo && this.categoryInfo.objectType;
    const dealType = this.categoryInfo && this.categoryInfo.dealType;

    const { sale: saleObjectTypes, rent: rentObjectTypes } = config.get('Commercial.newFPCategories');

    return (
      (dealType === 'sale' && saleObjectTypes.includes(objectType)) ||
      (dealType === 'rent' && rentObjectTypes.includes(objectType))
    );
  };

  const wasFormExpanded = () => {
    const guid = localStorage.getItem(`lastNewFPABDraftGuid${this.ad.category}`);

    return guid === this.ad.objectGuid;
  };

  // подписываемся на события, при которых надо обновить состав сегментов формы
  const setupUpdateSegmentsListeners = () => {
    $rootScope.$on('user.setUser', updateSegments);
    addFormLayoutService.onIsShortFormChange(updateSegments);
    jkService.onChangeJk(updateSegments);
    userService.onUserVerifyPhoneNumber(updateSegments);
    $rootScope.$on('addForm.updateSegments', updateSegments);
    $rootScope.$on('addForm.showRestForm', () => {
      this.canHideRestForm = false;
      this.canShowNextButton = false;
      updateSegments();
    });

    // обновляем сегменты при привязки БЦ. Это необходимо в случаях, когда в комм. недв. видим заявку на здание
    // и вводим адрес БЦ или выбираем БЦ из списка, в этом случае режим отображения формы не меняется,
    // поэтому надо обновить сегменты явно
    bsCenterService.onAttach(updateSegments);

    $scope.$watchCollection(
      () => ({
        category: this.ad.category,
        isByHomeowner: this.ad.isByHomeowner,
        isByCommercialOwner: this.ad.isByCommercialOwner,
        readyBusinessType: this.ad.readyBusinessType,
      }),
      () => {
        if (isFlatSale() || isCountrySide() || isCommercialNewFpCategory()) {
          this.canHideRestForm = true;
          this.canShowNextButton = true;
        }

        updateSegments();
      },
    );

    // обновляем сегменты при смене города в новостройках т.к. привязка к ЖК обязательна только в некоторых городах
    addressService.onAddressChanged((address, geoObject, isValid, locationChanged) => {
      if (jkService.isJkCategory() && locationChanged) {
        updateSegments();
      }
    });

    $rootScope.$on('jkService.jkCatalogAddformShowCheck', () => {
      // Если ЖК уже выбран, а форма еще не пересчиталась, то нам нужно принудительно обновить сегменты
      if (!jkService.showJkForm() && this.segments.indexOf('ad-submit-jk') > -1) {
        updateSegments();
      }
    });

    $scope.$watch(() => this.rosreestrData, updateSegments);
  };

  $scope.$watchGroup([() => this.categoryInfo.objectType, () => this.categoryInfo.rentDuration], () => {
    if (!this.form.remoteValidator) {
      this.form.remoteValidator = remoteValidationService.getInstance(this.form);
    }
  });

  $scope.$on('http.serverError', (event, data) => handleServerError(data));

  $scope.$on('http.unauthorized', () => {
    $log.warn('Ошибка сервера - 401');
  });

  $scope.$on('http.forbidden', () => {
    $log.warn('Ошибка сервера - 403');
  });

  this.needHideRestForm = () => {
    return (
      this.canHideRestForm &&
      !this.ad.id &&
      (isFlatSale() || isCountrySide() || isCommercialNewFpCategory()) &&
      !wasFormExpanded()
    );
  };

  this.isHomeownerConfirmationSent = () =>
    !this.isCommercialOwnerConfirmationSent() &&
    !!this.ad.homeOwner &&
    !!this.ad.homeOwner.cadastralNumber &&
    !!this.ad.homeOwner.firstName;

  this.showReportErrorModal = () => {
    analyticsService.trackReportErrorModalShow();

    popupService.openPopup('reportError');
  };

  this.showReportFormModal = () => {
    popupService.openPopup('reportForm');
  };

  $scope.$on('user.setUser', () => {
    if (!authService.isLastStepLogin) {
      getActiveDraft();
    }
  });

  $scope.$on('publish.skipPremoderationCheck', () => {
    if (publishTermsService.isNewPublishTermsEnabled()) {
      if (this.ad.status === 'published') {
        store.dispatch(publishOffer({ isPremoderationSkip: true }));
      }
    } else {
      this.submitForm(true);
    }
  });

  $rootScope.$on('publishAd', () => {
    this.submitForm();
  });

  setupUpdateSegmentsListeners();
  // todo: нужен рефакторинг
  // при открытии на редактирование инф. об адресе нужно знать очень рано, чтобы понять нужна ли короткая форма в жилой недв (БТИ)
  if (this.ad.geo && this.ad.geo.address) {
    addressService.setAddressInfo(this.ad.geo.address);
  }

  this.layoutService = addFormLayoutService;

  let formIsBlocked = this.user && this.user.isSubAgent && !this.user.subAgentCanPublishOffers;
  $rootScope.$on('user.setUser', (event, user) => {
    formIsBlocked = user.isSubAgent && !user.subAgentCanPublishOffers;
  });
  this.isFormBlocked = () => formIsBlocked;

  this.isWideFormEnabled = () => userService.user.termsHintAbGroup === 'new';

  $scope.$watch(
    () => advertiseObjectService.isRequestSend,
    () => {
      if (advertiseObjectService.isRequestSend) {
        this.isAdvertiseMyObjectBannerVisible = false;
      }
    },
  );

  /** Флаг, который не дает алгоритму предустановки коллтрекинга выполняться повторно */
  let isCalltrackingEnabledOnce = false;

  /**
   * Предустанавливает галочку КТ в зависимости от тарифа
   * Некоммерческий - не устанавливает
   * Профи и базовый - устанавливает
   */
  const updateTariffCalltracking = params => {
    const { calltrackingOption, isCalltrackingAvailable, isCalltrackingSelected, selectOption } = params;

    /* Ничего не делаем, если услуга коллтрекинга не пришла из биллинга */
    if (calltrackingOption) {
      /*
       * Не конфликтуем с кейсом обязательного КТ
       * Его установит функция updateCompulsoryCalltracking (см. ниже)
       */
      if (calltrackingOption.isCompulsory) {
        return;
      }

      const { user } = store.getState();
      const { isBase, isPro, isNonCommercial } = getUserTariff(user);

      /* Проверяем базовые условия, убеждаемся, что КТ в принципе доступен */
      if (this.ad.phones && this.ad.phones.some(isObject) && isCalltrackingAvailable) {
        /* Проверяем, что объявление новое */
        if (isNewOffer) {
          /*
              Проверяем, что тариф пользователя базовый/профи, что алгоритм отрабатывает первый раз
              или тариф некомерческий и выбран заданный регион CD-63408
            */
          if (
            ((isBase || isPro) && !isCalltrackingEnabledOnce) ||
            (isNonCommercial &&
              [TATARSTAN_REGION, KRASNOYARSK_REGION, NN_REGION, VORONEZH_REGION].includes(
                get(this.ad, 'geo.address[0].id'),
              ))
          ) {
            /* Если КТ уже выбран ранее (на другой итерации вотчинга), то пропускаем этот шаг */
            if (!isCalltrackingSelected()) {
              /* Выбираем КТ на ФП с помощью скрипта, так как хотим предустановить КТ по тарифу */
              selectOption(calltrackingOption);
              /* После первичной простановки коллтрекинга останавливаем алгоритм на сессию, не мешая пользователю */
              isCalltrackingEnabledOnce = true;
            }

            /*
              Порядок номеров телефонов может поменяться (первый можно удалить, второй ввести);
              Нам нужно убедиться, что телефон для КТ выбран при его автоматической активации,
              поэтому на каждой итерации обновляем индекс доступного номера телефона
            */
            this.ad.phones.forEach((phone, index) => {
              if (isObject(phone)) {
                this.ad.calltrackingPhoneIndex = index;
              }
            });
          }
        }
      }
    }
  };

  /**
    Обновляет статус обязательного КТ для данного региона
  */
  const updateCompulsoryCalltracking = params => {
    const { calltrackingOption, isCalltrackingAvailable, isCalltrackingSelected, selectOption, removeAdditionalById } =
      params;

    /*
      Специальный флаг, который форсит выбор услуги КТ
      Делаем главную проверку, чтобы производить действия только в контексте проекта
      обязательного КТ для региона, иначе можно форсить отключение КТ в другом регионе
    */
    if (!calltrackingOption || !calltrackingOption.isCompulsory) {
      return;
    }

    if (calltrackingOption && this.ad.phones && this.ad.phones.some(isObject) && isCalltrackingAvailable) {
      /* Если КТ уже выбран ранее (на другой итерации вотчинга), то пропускаем этот шаг */
      if (!isCalltrackingSelected()) {
        /* Выбираем КТ на ФП с помощью скрипта, так как услуга обязательная (compulsory) */
        selectOption(calltrackingOption);

        /*
          При выборе принудительного КТ мы должны хранить в объявлении то же количество номеров, которое доступно для подмены
          Это нужно для корректной работы интерфейса: мы выводим доступное для подмены количество полей для ввода номера
          Если не очистить невидимые телефоны в редактируемом объявлении, то их нельзя будет очистить вручную на клиенте
          Это приведет к блокировке ввода второго номера в интерфейсе, так как он уже введен как второй, а второе поле ввода скрыто
        */
        this.ad.phones = this.ad.phones.slice(0, calltrackingOption.calltrackingPhoneSubstitutionsCount);
      }
    } else {
      removeAdditionalById('calltracking');
    }
  };

  /**
   * Функция вызывается по триггеру доступности КТ в интерфейсе
   * и дает бизнес-логике обработать предустановки КТ (предвыбран, недоступен, etc.)
   */
  const updateCalltrackingSelection = (params = {}) => {
    /* Проект предвыбранного КТ по тарифу PM-4764 */
    updateTariffCalltracking(params);
    /* Проект обязательного КТ для региона PM-4264 */
    updateCompulsoryCalltracking(params);
  };

  /* Отслеживаем VAS КТ и доступность КТ в текущем регионе */
  if (publishTermsService.isNewPublishTermsEnabled()) {
    const updateCalltracking = calltracking => {
      const { isEnabled, isAvailable } = calltracking;

      updateCalltrackingSelection({
        calltrackingOption: calltracking,
        isCalltrackingAvailable: isAvailable,
        isCalltrackingSelected: () => isEnabled,
        selectOption: () => store.dispatch(setCalltrackingEnabled(true)),
        removeAdditionalById: () => store.dispatch(setCalltrackingEnabled(false)),
      });
    };

    $scope.$watch(() => store.getState().calltracking, updateCalltracking, true);

    /* Отслеживаем телефоны, чтобы выбрать какой-нибудь из них для обязательного КТ */
    $scope.$watchCollection(
      () => store.getState().offer.phones,
      () => {
        const { calltracking } = store.getState();

        updateCalltracking(calltracking);
      },
    );

    /* Отслеживаем наличие данных о пользователе */
    $scope.$watch(
      () => store.getState().user,
      () => {
        const { calltracking } = store.getState();

        updateCalltracking(calltracking);
      },
      true,
    );
  } else {
    $scope.$watchGroup([() => placingTermsApi.calltrackingOption, () => placingTermsApi.isCalltrackingAvailable], () =>
      updateCalltrackingSelection(placingTermsApi),
    );

    /* Отслеживаем телефоны, чтобы выбрать какой-нибудь из них для обязательного КТ */
    $scope.$watchCollection(
      () => this.ad.phones,
      () => updateCalltrackingSelection(placingTermsApi),
    );

    /* Отслеживаем наличие данных о пользователе */
    $scope.$watch(
      () => userService.user,
      () => updateCalltrackingSelection(placingTermsApi),
    );
  }

  // Автосохранение в localStorage(только для собственников)
  $scope.$watchGroup(
    [
      () => this.isShowPublishSuccess,
      () => addFormService.ad.isByHomeowner,
      () => addFormService.ad.isByCommercialOwner,
    ],
    newValues => {
      if (addFormService.ad.id) {
        return;
      }

      const [isShowPublishSuccess, isByHomeowner, isCommercialOwner] = newValues;
      const isLocalDraftAllowed = !!(!isShowPublishSuccess && (isByHomeowner || isCommercialOwner));

      activeDraftService.setLocalAutoSave(isLocalDraftAllowed);
    },
  );

  // Вызов gtm скриптов только для собов прошедших идентификацию на ФП;
  $scope.$watchGroup(
    [() => this.isShowPublishSuccess, userIdentificationService.getIsVisible, () => this.isFinallyPublished],
    ([isShowPublishSuccess, isVisible, isFinallyPublished]) => {
      if (isShowPublishSuccess && !isVisible && !isFinallyPublished) {
        this.checkGTMScripts();
      }
    },
  );

  $scope.$watch(activeDraftService.getDraftMode, mode => {
    this.draftModeIsLocal = mode === activeDraftService.modeEnums.LOCAL;
  });

  // Попытка восстановить данные сохраненные при смене региона
  window.addEventListener('load', () => {
    subdomainDraftService.fetchSubdomainDraft().then(draft => {
      if (!draft) {
        return;
      }

      this.ad = { ...draft };

      // timeout, чтобы дождаться стирание building, вызываемый в setBuildingTypeByCateogryAndPlacementType
      if (draft.building) {
        $timeout(() => (this.ad.building = draft.building), 0);
      }

      $scope.$apply();
    });
  });

  this.checkGTMScripts = () => {
    if ($window.gtm && Array.isArray($window.gtm.scripts)) {
      $window.gtm.scripts.forEach(func => {
        try {
          func.call(this, this.ad, userService.user, userIdentificationService.getUserStatusByAd());
          // eslint-disable-next-line no-empty
        } catch (err) {}
      });
    }
  };

  this.isBodyHidden = () => {
    return (
      this.isFormBlocked() ||
      this.isShowPublishSuccess ||
      this.isShowIvrCheck ||
      this.userIdentificationService.getIsVisible() ||
      this.userIdentificationService.getIsSelectPageVisible()
    );
  };

  this.isHeaderHidden = () => {
    return (
      this.isShowPublishSuccess ||
      this.userIdentificationService.getIsVisible() ||
      this.headerPromoService.isVisible ||
      this.userIdentificationService.getIsSelectPageVisible()
    );
  };

  this.isHeaderPromoHidden = () => {
    return (
      this.isFormBlocked() ||
      this.isShowPublishSuccess ||
      this.userIdentificationService.getIsVisible() ||
      this.userIdentificationService.getIsSelectPageVisible()
    );
  };

  this.isIvrCheckShown = () => {
    return this.isShowIvrCheck;
  };

  this.isPreviewShown = () => {
    return (
      this.isShowPublishSuccess &&
      !this.userIdentificationService.getIsVisible() &&
      !this.userIdentificationService.getIsSelectPageVisible()
    );
  };

  this.isCommercialOwnerConfirmationSent = () => commercialOwnerService.shouldRosreestCaptionVisible();

  $scope.handleRetryPublishClick = () => {
    if (publishTermsService.isNewPublishTermsEnabled()) {
      store.dispatch(publishOffer({ isPremoderationSkip: false }));
    } else {
      this.submitForm();
    }
  };

  listenEvent(PUBLISH_OFFER_START, async ({ isPremoderationSkip }) => {
    $rootScope.$broadcast('addform.submit');

    prepublishReset();

    $timeout(() => {
      this.form.$setSubmitted();
    });

    const { offer } = store.getState();

    const isFormInvalid = checkFormValidity(offer.id);

    if (isFormInvalid) {
      store.dispatch(offerValidationFail());

      return;
    }

    const isPremoderationCheckSuccess = await runPremoderationCheck({ offer, isPremoderationSkip });

    if (!isPremoderationCheckSuccess) {
      return;
    }

    this.publishAdProcess = true;

    $scope.$apply();
  });

  listenEvent(PUBLISH_OFFER_SUCCESS, data => {
    publishOfferSuccess({
      response: { data },
    });
  });

  listenEvent(PUBLISH_OFFER_FAIL, ({ statusCode, payload }) => {
    publishOfferFail({
      statusCode,
      response: { data: payload },
    });
  });

  listenEvent(SAVE_DRAFT_START, () => {
    $rootScope.$broadcast('addform.submit');

    prepublishReset();

    $timeout(() => {
      this.form.$setSubmitted();
    });

    const { offer } = store.getState();

    const isFormInvalid = checkFormValidity(offer.id);

    if (isFormInvalid) {
      store.dispatch(offerValidationFail());

      return;
    }

    store.dispatch(offerValidationSuccess());

    this.draftAdProcess = true;

    $scope.$apply();
  });

  listenEvent(SAVE_DRAFT_SUCCESS, data => {
    saveDraftSuccess({
      response: { data },
    });
  });

  listenEvent(SAVE_DRAFT_FAIL, ({ statusCode, payload }) => {
    saveDraftFail({
      statusCode,
      response: { data: payload },
    });
  });
}
